module.exports = __webpack_public_path__ + "static/media/masjid.4a63ce56.jfif";